const makeInitialState = relatedInvoiceData => {
  return {
    invoiceType: relatedInvoiceData?.invoiceType || null,
    category: relatedInvoiceData?.category || null,
    contractId: relatedInvoiceData?.contractId || null,
    clientId: relatedInvoiceData?.clientId || null,
    clientName: relatedInvoiceData?.clientName || null,
    folio: relatedInvoiceData?.folio || null,
    amount: relatedInvoiceData?.amount || 0,
    comment: relatedInvoiceData?.comment || '',
    paymentMethod: relatedInvoiceData?.paymentMethod || null,
    paymentForm: relatedInvoiceData?.paymentForm || null,
    paymentDate: relatedInvoiceData?.paymentDate || null,
    relatedDocuments: relatedInvoiceData?.relatedDocuments || null
  };
};

export default makeInitialState;
